import { useEffect, useRef, useState } from "react";
import { OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";
import { useTooltips } from "../../context/TooltipsContext";

const EnergoTooltip = ({position, color, style, tKey, msg}) => {

    const { tooltips, tooltipsTrigger, tooltipsLoading } = useTooltips();
    const [helpText, setHelpText] = useState(msg? msg : "");

    const textColor = color || "text-energo";
    const target = useRef(null);

    useEffect(() => {
        if (tooltips && tooltips.length > 0 && !msg) {
            console.log(tooltips)
            var wanted = tooltips.find(t => t && t.code != null && tKey != null && t.code.toString() === tKey.toString());
            if (wanted) {
                setHelpText(wanted.help_text);
            }
        }
    }, [tooltips, msg])

    const renderTooltip = (props) => (
        <Tooltip id={`tooltip-${tKey}`} {...props}>
            {tooltipsLoading ? 
                <Spinner animation="border" /> :
                helpText
            }
        </Tooltip>
    );

    return (
        tooltipsTrigger && (!tooltipsLoading && helpText) &&
        <div key={`tooltip-icon-${tKey}`}>
                <OverlayTrigger
                    placement={position}
                    delay={{ show: 250, hide: 400}}
                    overlay={renderTooltip}
                >
                    <span ref={target}>
                        <FaInfoCircle
                            style={{
                                width: 18,
                                height: 18,
                                minWidth: 18,
                                minHeight: 18,
                                fontSize: 18,
                                display: "block",
                                flexShrink: 0,
                                ...style
                            }}
                            className={textColor}
                            onClick={e => e.preventDefault()}
                        />
                    </span>
                </OverlayTrigger>
        </div>
    )
}
export default EnergoTooltip;